import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import type { MultidietPopupType } from "@/features/multidiet-picker/types/multidiet-popup.type";
import {
  fetchStrapiFromClient,
  type StrapiClientResponse,
} from "@/services/strapi-client";

type MultidietPopupResponseType = StrapiClientResponse<MultidietPopupType>;

type UseMultidietSetupParams = {
  options?: Omit<
    UseQueryOptions<
      MultidietPopupResponseType,
      unknown,
      MultidietPopupResponseType,
      string[]
    >,
    "queryFn" | "queryKey"
  >;
};

export const useMultidietPopup = ({ options }: UseMultidietSetupParams) => {
  return useQuery({
    queryKey: ["multidiet-popup"],
    // Through the Strapi proxy route rather than a Server Action, whose id
    // does not survive a deploy (Sentry WEB-22A).
    queryFn: () =>
      fetchStrapiFromClient<MultidietPopupType>("/multidiet-popup"),
    ...options,
  });
};
